import { showConfirmAlert } from "../../../shared/components/generic/alert/confirm-alert/confirm-alert";
import { showCommonAlert } from "../../../shared/components/generic/alert/utils/show-common-alert-utils";
import { TokenUtils } from "../../../shared/utils/TokenUtils";

export const hasAdminPermission = (userSession, permission) => {
	if (!permission) {
		return true;
	}

	const sessionModules = userSession?.modulos || [];
	const tokenModules = TokenUtils.getTokenData()?.modulos || [];

	const modules = [
		...sessionModules,
		...tokenModules
	]
		.map(getModuleName)
		.filter(Boolean);

	return modules.includes(permission);
};

export const onlyNumbers = value => {
	return String(value || "").replace(/\D/g, "");
};

export const decimalNumberMask = (value, decimalPlaces = 1) => {
	const normalizedValue = String(value || "")
		.replace(/\./g, ",")
		.replace(/[^\d,]/g, "");

	const firstCommaIndex = normalizedValue.indexOf(",");

	if (firstCommaIndex === -1) {
		return normalizedValue;
	}

	const integerPart = normalizedValue.slice(0, firstCommaIndex);
	const decimalPart = normalizedValue
		.slice(firstCommaIndex + 1)
		.replace(/,/g, "")
		.slice(0, decimalPlaces);

	return `${integerPart},${decimalPart}`;
};

const getModuleName = module => {
	if (typeof module === "string") {
		return module;
	}

	return module?.nome ||
		module?.codigo ||
		module?.chave ||
		module?.key ||
		"";
};

export const confirmSaveChanges = ({
	description = "Deseja salvar as alterações?"
} = {}) => {
	return showConfirmAlert({
		title: "Salvar alterações",
		description,
		confirmLabel: "Sim, salvar",
		cancelLabel: "Cancelar"
	});
};

export const buildParams = (pagination = {}) => {
    const {
        page,
        size
    } = pagination;

    const params = new URLSearchParams();

    if (page !== undefined && page !== null) {
        params.append("page", page);
    }

    if (size !== undefined && size !== null) {
        params.append("size", size);
    }

    return params;
};

export const showNoRecordsFoundAlert = () => {
	return showCommonAlert({
		title: "Aviso",
		message: "Nenhum registro encontrado.",
		icon: "warning",
		customClass: {
			container: "common-alert__container",
			confirmButton: "alert-form-button"
		}
	});
};

export const percentageMask = (
	value,
	{
		integerPlaces = 3,
		decimalPlaces = 2
	} = {}
) => {
	const onlyNumbers = String(value || "").replace(/\D/g, "");

	if (!onlyNumbers) {
		return "";
	}

	const maxLength = integerPlaces + decimalPlaces;
	const limitedNumbers = onlyNumbers.slice(0, maxLength);

	const paddedNumbers = limitedNumbers.padStart(decimalPlaces + 1, "0");

	const integerPart = paddedNumbers.slice(0, -decimalPlaces);
	const decimalPart = paddedNumbers.slice(-decimalPlaces);

	const trimmedIntegerPart = String(Number(integerPart));

	return `${trimmedIntegerPart},${decimalPart}`;
};

export const formatPercentageInputValue = (
	value,
	{
		decimalPlaces = 2
	} = {}
) => {
	if (value === undefined || value === null || value === "") {
		return "";
	}

	const normalizedValue = String(value)
		.replace(".", ",")
		.replace(/[^\d,]/g, "");

	const [integerPart = "0", decimalPart = ""] = normalizedValue.split(",");

	return `${Number(integerPart)},${decimalPart
		.padEnd(decimalPlaces, "0")
		.slice(0, decimalPlaces)}`;
};

export const isValidPercentageNumber = (
	value,
	{
		integerPlaces = 3,
		decimalPlaces = 2
	} = {}
) => {
	const normalizedValue = String(value || "").trim();

	if (!normalizedValue) {
		return false;
	}

	const regex = new RegExp(
		`^\\d{1,${integerPlaces}}(,\\d{1,${decimalPlaces}})?$`
	);

	return regex.test(normalizedValue);
};